module.exports = __webpack_public_path__ + "img/lk-close.4f393a8e.png";